<router-outlet></router-outlet>

<vex-loader></vex-loader>
